import React, { useState } from 'react';
import { Navbar } from '@/components/Navbar';
import { Footer } from '@/components/Footer';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Users, UserPlus } from 'lucide-react';
import TeachersManager from '@/components/settings/TeachersManager';
import InvitationModal from '@/components/settings/InvitationModal';
import { useLanguage } from '@/contexts/LanguageContext';
import { useAuth } from '@/contexts/AuthContext';

const TeachersPage = () => {
  const { t } = useLanguage();
  const { user } = useAuth();
  const [isInvitationModalOpen, setIsInvitationModalOpen] = useState(false);

  const isSchool = user?.account_type === "S";

  return (
    <div className="min-h-screen flex flex-col">
      <Navbar />

      <main className="flex-1 container py-8 mt-16">
        <Card className="border shadow-md">
          <CardHeader>
            <div className="flex items-center justify-between">
              <CardTitle className="text-xl flex items-center gap-2">
                <Users className="h-5 w-5" />
                {t('teachers.title')}
              </CardTitle>
            </div>
          </CardHeader>
          <CardContent>
            {isSchool && (
              <TeachersManager
                showInvitationButton={isSchool}
                onInviteClick={() => setIsInvitationModalOpen(true)}
              />
            )}
          </CardContent>
        </Card>
      </main>

      <InvitationModal
        isOpen={isInvitationModalOpen}
        onClose={() => setIsInvitationModalOpen(false)}
        userType="school"
      />

      <Footer />
    </div>
  );
};

export default TeachersPage;
